export default __webpack_public_path__ + "static/media/nav_img_14.176dc05c.jpg";